import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-input-text',
  templateUrl: './st-input-text.component.html',
  styleUrls: ['./st-input-text.component.scss'],
  standalone: false
})
export class StInputTextComponent {

  @Input()
  label = 'FIELD LABEL';

  @Input()
  idVal: string = 'textId';

  @Input()
  inputVal: string = '';

  @Input()
  placeHolderVal = 'Type here';

  @Input()
  maxLength: number = 200;

  @Input()
  disabled: boolean = false;

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000';

  @Input()
  requiredVal: boolean = false;

  @Output()
  onClick = new EventEmitter<Event>();
}
